import { useCallback, useRef, useState } from 'react';

export const useBoardSelectionBox = () => {
  const selectionBoxRef = useRef(null);
  const [selectionBox, setSelectionBoxState] = useState(null);

  const setSelectionBox = useCallback(nextValue => {
    const resolvedValue =
      typeof nextValue === 'function'
        ? nextValue(selectionBoxRef.current)
        : nextValue;
    selectionBoxRef.current = resolvedValue;
    setSelectionBoxState(resolvedValue);
    return resolvedValue;
  }, []);

  const startSelectionBox = useCallback(
    initialValue => setSelectionBox(initialValue),
    [setSelectionBox],
  );

  const updateSelectionBox = useCallback(
    patch => {
      if (!selectionBoxRef.current) {
        return null;
      }
      return setSelectionBox({
        ...selectionBoxRef.current,
        ...patch,
      });
    },
    [setSelectionBox],
  );

  const clearSelectionBox = useCallback(() => {
    selectionBoxRef.current = null;
    setSelectionBoxState(null);
  }, []);

  return {
    selectionBox,
    selectionBoxRef,
    setSelectionBox,
    startSelectionBox,
    updateSelectionBox,
    clearSelectionBox,
  };
};
